/**
 * Social - Print - Share
 */

import React from 'react'

function handlePrint() {
  setTimeout(() => {
    if (window) {
      window.print()
    }
  }, 100)
}

// eslint-disable-next-line import/prefer-default-export
export const PrintShare = () => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a aria-label='print' href="#" onClick={handlePrint}>
    <i className="fas fa-print" />
  </a>
)
